import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  CircleMarker,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import api from "../../../utils/axios";
import moment from "moment";
import "moment/locale/th";
import FileModalLocation from "../Modal/FileModalAppointment";
import Swal from "sweetalert2";
// ⭐ เพิ่ม 2 บรรทัดนี้บนสุด
import FullPageModal from "../Modal/FullCustomerModal";
import EditCustomerPage from "../../pages/Sale/EditCustomer";


export default function AppointmentDetailModal({
  isOpen,
  onClose,
  appoint,
  onUpdated,
}) {
  const [files, setFiles] = useState([]);
  const [serviceInfo, setServiceInfo] = useState(null);
  const [showFileModal, setShowFileModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [gps, setGps] = useState({ lat: null, lng: null });
  const [openCustomerPage, setOpenCustomerPage] = useState(false);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [titles, setTitles] = useState([]);

  // ตรวจสอบ role ของ user
  const role = localStorage.getItem("role");
  const roleCode = localStorage.getItem("role_code");
  const isAdmin = role === "Admin" || roleCode === "1" || roleCode === "2";



  const [form, setForm] = useState({
    Width: "",
    Length: "",
    Height: "",
    SpecRemark: "",
    Appoint_Remark: "",
  });

  const loadAppointDetail = async () => {
    try {
      const res = await api.get(`/get-appoint-by-id/${appoint.Appoint_Id}`);
      const a = res.data?.result?.recordset?.[0];

      if (a) {
        setForm({
          Width: a.Width || "",
          Length: a.Length || "",
          Height: a.Height || "",
          SpecRemark: a.SpecRemark || "",
          Appoint_Remark: a.Appoint_Remark || "",
        });
      }
    } catch (err) {
      console.error("โหลดข้อมูลนัดหมายผิดพลาด:", err);
    }
  };

  useEffect(() => {
    if (!isOpen || !appoint?.AR_Id) return;

    api.get(`/get-tb-set-ar1/${appoint.AR_Id}`).then((res) => {
      setCustomerInfo(res.data?.result?.recordset?.[0] || null);
    });
  }, [isOpen, appoint]);

  useEffect(() => {
    const fetchTitles = async () => {
      try {
        const res = await api.get("/get-title");
        if (res.data.status === "OK") {
          setTitles(res.data.result || []);
        }
      } catch (err) {
        console.error("โหลดคำนำหน้าไม่สำเร็จ:", err);
      }
    };

    fetchTitles();
  }, []);



  const getLocation = () => {
    if (!navigator.geolocation) {
      return Swal.fire("ไม่รองรับ GPS", "อุปกรณ์นี้ไม่รองรับการระบุตำแหน่ง", "error");
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        setGps({ lat, lng });
      },
      () => Swal.fire("ผิดพลาด", "ไม่สามารถดึงตำแหน่งได้", "error")
    );
  };

  //  โหลดข้อมูลเมื่อ Modal เปิด
  useEffect(() => {
    if (!isOpen || !appoint?.Appoint_Id) return;

    //  โหลดไฟล์แนบ
    api.get(`/get-appoint-files/${appoint.Appoint_Id}`).then((res) => {
      const list = res.data?.result?.recordset || [];
      setFiles(
        list.map((f) => ({
          id: f.File_Id,
          name: f.FileName,
          url: f.FilePath,
          type: f.FileType || "file",
        }))
      );
    });

    //  โหลดข้อมูลสถานที่ บริการ
    if (appoint.ServiceAddr_Id) {
      api
        .get(`/get-tb-set-service-addr-by-id/${appoint.ServiceAddr_Id}`)
        .then((res) => {
          let data = res.data?.result?.recordset?.[0];
          if (data) setServiceInfo(data);
        });
    }

    //  โหลดข้อมูลนัดหมายจาก DB แท้ๆ
    loadAppointDetail();
  }, [isOpen, appoint]);

  if (!isOpen || !appoint) return null;

  const formatDateTime = (dateStr, timeStr) => {
    if (!dateStr) return "-";
    const d = moment(dateStr);
    const thaiYear = d.year() + 543;
    const date = d.format(`DD/MM/${thaiYear}`);
    if (!timeStr) return date;
    return `${date} ${timeStr.substring(0, 5)} น.`;
  };

  const hasCheckin = appoint.Sale_Latitude && appoint.Sale_Longitude;

  const getDistanceKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const toRad = (d) => (d * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  const distance =
    hasCheckin && serviceInfo?.Latitude && serviceInfo?.Longitude
      ? getDistanceKm(
          Number(serviceInfo.Latitude),
          Number(serviceInfo.Longitude),
          Number(appoint.Sale_Latitude),
          Number(appoint.Sale_Longitude)
        ).toFixed(2)
      : null;

  //  แสดงสถานะตามหน้าปฏิทิน
  const renderStatus = () => {
    const eventType = appoint.EventType || (appoint.Appoint_Id ? "APPOINT" : appoint.Call_Id ? "CALL" : null);
    
    // กรณีเป็น Appointment (นัดหมายเพื่อเข้าพบ)
    if (eventType === "APPOINT" || appoint.Appoint_Id) {
      // ใช้ form.SpecRemark (โหลดจาก API) หรือ appoint.SpecRemark (จาก calendar)
      const specRemark = form.SpecRemark || appoint.SpecRemark || "";
      const hasSpecRemark = specRemark && specRemark.trim() !== "";
      
      // ยังไม่มีผลการเข้าพบ - สี #3b82f6
      if (!hasSpecRemark) {
        return (
          <span className="text-white px-3 py-1 rounded-pill" style={{ backgroundColor: "#3b82f6" }}>
            นัดหมายเพื่อเข้าพบ
          </span>
        );
      }
      
      // มีผลการเข้าพบแล้ว - ตรวจสอบระยะทาง
      const saleLat = appoint.Sale_Latitude;
      const saleLng = appoint.Sale_Longitude;
      const saLat = serviceInfo?.Latitude;
      const saLng = serviceInfo?.Longitude;
      
      if (hasSpecRemark && saleLat && saleLng && saLat && saLng) {
        const distanceKm = getDistanceKm(
          Number(saLat),
          Number(saLng),
          Number(saleLat),
          Number(saleLng)
        );
        
        // นอกระยะทำการ - สี #f87171
        if (distanceKm > 1) {
          return (
            <span className="text-white px-3 py-1 rounded-pill" style={{ backgroundColor: "#f87171" }}>
              นัดหมายเพื่อเข้าพบ
            </span>
          );
        }
      }
      
      // มีผลการเข้าพบแล้ว (ในระยะหรือไม่มีพิกัด) - สี #4ade80
      return (
        <span className="text-white px-3 py-1 rounded-pill" style={{ backgroundColor: "#4ade80" }}>
          นัดหมายเพื่อเข้าพบ
        </span>
      );
    }
    
    // กรณีเป็น Call (นัดหมายเพื่อโทร)
    if (eventType === "CALL" || appoint.Call_Id) {
      const callType = appoint.Call_Type;
      const callResult = appoint.Call_Result || "";
      const hasResult = callResult && callResult.trim() !== "";
      
      // นัดหมายเพื่อโทร (Call_Type = 2)
      if (callType === 2 || callType === "2") {
        if (!hasResult) {
          // ยังไม่มีผลการโทร - สี #1D4ED8
          return (
            <span className="text-white px-3 py-1 rounded-pill" style={{ backgroundColor: "#1D4ED8" }}>
              นัดหมายเพื่อโทร
            </span>
          );
        } else {
          // มีผลการโทรแล้ว - สี #9333EA
          return (
            <span className="text-white px-3 py-1 rounded-pill" style={{ backgroundColor: "#9333EA" }}>
              นัดหมายเพื่อโทร
            </span>
          );
        }
      }
    }
    
    //  กรณี fallback ที่ไม่ควรเกิด
    return (
      <span className="bg-gray-500 text-white px-3 py-1 rounded-pill">
        - ไม่ทราบสถานะ -
      </span>
    );
  };

  const CustomerInfoBlock = ({ customer, titles }) => {
    if (!customer) return <p>กำลังโหลดข้อมูลลูกค้า...</p>;

    const getFullName = () => {
      const titleObj = titles.find(
        (t) => Number(t.Title_Id) === Number(customer.AR_TitleCode)
      );
      const title = titleObj ? titleObj.Title_Name : "";
      const name = customer.AR_Name || "";
      const lastName = customer.AR_LastName || "";
      return `${title ? title + " " : ""}${name}${lastName ? " " + lastName : ""}`.trim() || "-";
    };

    const formatTax = (tax) =>
      tax
        ? tax.replace(/^(\d{1})(\d{4})(\d{5})(\d{2})(\d{1})$/, "$1-$2-$3-$4-$5")
        : "-";

    const rows = [
      { label: "ชื่อลูกค้า / บริษัท", value: getFullName() },
      { label: "ชื่อในสัญญา", value: customer.DisplayName || "-" },
      { label: "ประเภทลูกค้า", value: customer.AR_Group === 1 ? "บุคคลธรรมดา" : "นิติบุคคล" },
      { label: "เลขผู้เสียภาษี", value: formatTax(customer.AR_TaxNo) },
      {
        label: "หมดสัญญา",
        value: customer.Contract_EndDate
          ? moment(customer.Contract_EndDate).add(543, "year").format("MMMM YY")
          : "-",
      },
      { label: "คู่แข่ง", value: customer.Competitor || "-" },
      {
        label: "ราคาคู่แข่ง",
        value:
          customer.CompetitorPrice && !isNaN(customer.CompetitorPrice)
            ? parseFloat(customer.CompetitorPrice).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "-",
      },
    ];

    return (
      <div className="space-y-2 text-sm">
        {rows.map((row) => (
          <div key={row.label} className="flex gap-2 items-start">
            {/* หัวข้อ: ไม่ถูกตัด, ไม่ถูกบีบ */}
            <span className="font-bold text-gray-700 whitespace-nowrap flex-shrink-0 w-40">
              {row.label}
            </span>

            {/* ":" คงที่ ไม่โดนบีบ */}
            <span className="font-bold flex-shrink-0">:</span>

            {/* ข้อความ: ตัดบรรทัดได้ */}
            <span className="break-words flex-1">{row.value}</span>
          </div>
        ))}
      </div>
    );
  };




  const handleSave = async () => {
    try {
      let lat = null;
      let lng = null;

      if (navigator.geolocation) {
        await new Promise((resolve) => {
          navigator.geolocation.getCurrentPosition(
            (pos) => {
              lat = pos.coords.latitude;
              lng = pos.coords.longitude;
              resolve();
            },
            () => resolve()
          );
        });
      }

      const payload = {
        Width: form.Width || null,
        Length: form.Length || null,
        Height: form.Height || null,
        SpecRemark: form.SpecRemark || "",
        Appoint_Remark: form.Appoint_Remark || "",
        Latitude: lat,
        Longitude: lng,
      };

      const res = await api.put(
        `/update-appoint/${appoint.Appoint_Id}`,
        payload
      );

      if (res.data.status === "OK") {
        setEditMode(false);
        onClose();
        onUpdated?.();
      } else {
        Swal.fire("ผิดพลาด", res.data.message || "บันทึกไม่สำเร็จ", "error");
      }
    } catch (err) {
      Swal.fire("ผิดพลาด", "ไม่สามารถบันทึกข้อมูลได้", "error");
    }
  };


  return (
  <div
    className="fixed inset-0 bg-black/50 flex items-center justify-center z-[3000]"
  >
    <div
      className="bg-white w-full max-w-3xl rounded-lg shadow p-6 max-h-[90vh] overflow-y-auto relative"
      onClick={(e) => e.stopPropagation()}   // ป้องกันปิด เฉพาะคลิกข้างใน
    >


      <div className="flex items-center justify-between border-b pb-2 mb-4">
        <h2 className="font-bold text-lg flex items-center gap-2 text-[#E13F57]">
          <Icon icon="mdi:calendar" className="w-5 h-5" />
          รายละเอียดการนัดหมาย
        </h2>

        <div className="flex items-center gap-3">

          <button
            onClick={(e) => {
              e.stopPropagation();
              setOpenCustomerPage(true);
            }}
            className="text-blue-600 hover:text-blue-800 underline font-semibold"
          >
            🔍 เปิดข้อมูลลูกค้า
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            className="text-gray-500 hover:text-gray-700"
          >
            ✕
          </button>
        </div>
      </div>



        {/* 🔥 แบ่งซ้ายขวา */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mb-6">

          {/* 🔄 1) ซ้าย = ข้อมูลลูกค้า (กิน 8 col) */}
          <div className="md:col-span-8 bg-gray-50 p-3 rounded-lg border">
            <h3 className="font-semibold text-gray-700 mb-2">ข้อมูลลูกค้า</h3>
            <CustomerInfoBlock customer={customerInfo} titles={titles} />
          </div>

          {/* 🔄 2) ขวา = สถานะ + ไฟล์แนบ (กิน 4 col) */}
          <div className="md:col-span-4">

            {/* สถานะ */}
            <div className="mb-3">
              <h3 className="font-semibold text-gray-700">สถานะ</h3>
              {renderStatus()}
            </div>

            {/* ไฟล์แนบ */}
            <div className="mb-3">
              <h3 className="font-semibold text-gray-700">ไฟล์แนบ</h3>
              <button
                onClick={() => setShowFileModal(true)}
                className="bg-[#F17F25] text-white px-4 py-2 rounded-lg flex items-center gap-2 mt-2 w-full justify-center"
              >
                <Icon icon="mdi:paperclip" className="w-5 h-5" />
                ดู/เพิ่มไฟล์แนบ
                {files.length > 0 && (
                  <span className="ml-1 bg-red-600 text-white text-xs px-2 py-[1px] rounded-full">
                    {files.length}
                  </span>
                )}
              </button>
            </div>

          </div>

        </div>


        

        {/*  แผนที่ - แสดงเฉพาะ Admin */}
        {hasCheckin && serviceInfo && isAdmin && (
          <div className="mb-4">
            <h3 className="font-semibold text-gray-700 mb-2">แผนที่เช็คอิน</h3>

            <MapContainer
              center={[
                serviceInfo.Latitude || 13.7563,
                serviceInfo.Longitude || 100.5018,
              ]}
              zoom={16}
              style={{ height: "260px", width: "100%" }}
            >
              <TileLayer url="https://mt1.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}" />

              <Marker position={[serviceInfo.Latitude, serviceInfo.Longitude]}>
                <Popup>สถานที่บริการ</Popup>
              </Marker>

              <CircleMarker
                center={[serviceInfo.Latitude, serviceInfo.Longitude]}
                radius={10}
                pathOptions={{
                  color: "#2563eb",
                  fillColor: "#2563eb",
                  fillOpacity: 0.9,
                }}
              />

              <CircleMarker
                center={[appoint.Sale_Latitude, appoint.Sale_Longitude]}
                radius={10}
                pathOptions={{
                  color: "#16a34a",
                  fillColor: "#16a34a",
                  fillOpacity: 0.9,
                }}
              />

              <Polyline
                positions={[
                  [serviceInfo.Latitude, serviceInfo.Longitude],
                  [appoint.Sale_Latitude, appoint.Sale_Longitude],
                ]}
                pathOptions={{ color: "#2563eb", weight: 3 }}
              />
            </MapContainer>

            <p className="text-sm mt-2">
              ระยะทางจากจุดบริการ: <b>{distance} กม.</b>
            </p>
          </div>
        )}

        {/*  ข้อมูลหลังเข้าพื้นที่ */}
        <div className="mb-4 border rounded-lg p-3 shadow-sm relative">
          {!editMode && (
            <button
              onClick={() => setEditMode(true)}
              className="absolute right-3 top-3 text-[#E13F57] hover:text-[#b1223e] flex items-center gap-1"
            >
              <Icon icon="mdi:pencil" className="w-5 h-5" /> แก้ไข
            </button>
          )}

          <h3 className="font-semibold text-gray-700 mb-2">
            ข้อมูลหลังเข้าพื้นที่
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div>
              <label className="block text-sm mb-1">กว้าง (ม.)</label>
              <input
                type="number"
                value={form.Width}
                disabled={!editMode}
                onChange={(e) => setForm({ ...form, Width: e.target.value })}
                className={`w-full border rounded px-3 py-2 h-[32px] ${
                  editMode ? "bg-white" : "bg-gray-100"
                }`}
              />
            </div>

            <div>
              <label className="block text-sm mb-1">ยาว (ม.)</label>
              <input
                type="number"
                value={form.Length}
                disabled={!editMode}
                onChange={(e) => setForm({ ...form, Length: e.target.value })}
                className={`w-full border rounded px-3 py-2 h-[32px] ${
                  editMode ? "bg-white" : "bg-gray-100"
                }`}
              />
            </div>

            <div>
              <label className="block text-sm mb-1">สูง (ชั้น)</label>
              <input
                type="number"
                value={form.Height}
                disabled={!editMode}
                onChange={(e) => setForm({ ...form, Height: e.target.value })}
                className={`w-full border rounded px-3 py-2 h-[32px] ${
                  editMode ? "bg-white" : "bg-gray-100"
                }`}
              />
            </div>
          </div>

          <div className="mt-3">
            <label className="block text-sm mb-1 whitespace-nowrap">ผลการนัดหมาย</label>
            <textarea
              value={form.SpecRemark}
              disabled={!editMode}
              onChange={(e) =>
                setForm({ ...form, SpecRemark: e.target.value })
              }
              className={`w-full border rounded px-3 py-2 h-[100px] ${
                editMode ? "bg-white" : "bg-gray-100"
              }`}
            />
          </div>

          <div className="mt-3">
            <label className="block text-sm mb-1 whitespace-nowrap">รายละเอียดเพิ่มเติม</label>
            <textarea
              value={form.Appoint_Remark}
              disabled={!editMode}
              onChange={(e) =>
                setForm({ ...form, Appoint_Remark: e.target.value })
              }
              className={`w-full border rounded px-3 py-2 h-[120px] ${
                editMode ? "bg-white" : "bg-gray-100"
              }`}
            />
          </div>
        </div>

        {/*  Footer */}
        <div className="text-end flex gap-3 justify-end">
          {editMode ? (
            <>
              <button
                className="border border-gray-400 text-gray-700 px-5 py-2 rounded-lg"
                onClick={() => {
                  setEditMode(false);
                  loadAppointDetail();
                }}
              >
                ยกเลิก
              </button>

              <button
                className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg"
                onClick={handleSave}
              >
                บันทึก
              </button>
            </>
          ) : (
            <button
              className="bg-[#E13F57] hover:bg-[#c42e48] text-white px-5 py-2 rounded-lg"
              onClick={onClose}
            >
              ปิด
            </button>
          )}
        </div>
      </div>

      {/*  Modal ไฟล์แนบ */}
      {showFileModal && (
        <FileModalLocation
          mode="E"
          showViewAttachModal={showFileModal}
          setShowViewAttachModal={setShowFileModal}
          selectedFiles={files}
          setSelectedFiles={setFiles}
          Appoint_Id={appoint.Appoint_Id}
          ServiceAddr_Id={appoint.ServiceAddr_Id}
        />
      )}

      {/* ⭐ Full Page Modal → เปิดหน้า EditCustomerPage */}
      {openCustomerPage && (
        <FullPageModal
          isOpen={openCustomerPage}
          onClose={() => setOpenCustomerPage(false)}
        >
          <EditCustomerPage embedded={true} id={appoint.AR_Id} />
        </FullPageModal>
      )}

    </div>
  );
}
